const googleSvg2 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="30"
    width="30"
    id="svg60"
    version="1.1"
    viewBox="-4.12599 -7.65905 35.75858 45.9543"
  >
    <defs id="defs38">
      <linearGradient
        gradientUnits="userSpaceOnUse"
        y2="21.86"
        x2="-5.9"
        y1="1.87"
        x1="14.09"
        id="linear-gradient"
      >
        <stop id="stop4" stopColor="#008eff" offset="0" />
        <stop id="stop6" stopColor="#008fff" offset=".01" />
        <stop id="stop8" stopColor="#00acff" offset=".26" />
        <stop id="stop10" stopColor="#00c0ff" offset=".51" />
        <stop id="stop12" stopColor="#00cdff" offset=".76" />
        <stop id="stop14" stopColor="#00d1ff" offset="1" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        y2="15.32"
        x2="-2.37"
        y1="15.32"
        x1="26.45"
        id="linear-gradient-2"
      >
        <stop id="stop17" stopColor="#ffd800" offset="0" />
        <stop id="stop19" stopColor="#ff8a00" offset="1" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        y2="45.15"
        x2="-9.41"
        y1="18.05"
        x1="17.69"
        id="linear-gradient-3"
      >
        <stop id="stop22" stopColor="#ff3a44" offset="0" />
        <stop id="stop24" stopColor="#b11162" offset="1" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        y2="3.81"
        x2="8.92"
        y1="-8.29"
        x1="-3.19"
        id="linear-gradient-4"
      >
        <stop id="stop27" stopColor="#328e71" offset="0" />
        <stop id="stop29" stopColor="#2d9571" offset=".07" />
        <stop id="stop31" stopColor="#15bd74" offset=".48" />
        <stop id="stop33" stopColor="#06d575" offset=".8" />
        <stop id="stop35" stopColor="#00de76" offset="1" />
      </linearGradient>
      <style id="style2"></style>
    </defs>
    <g transform="translate(.004)" id="g58">
      <g id="g56">
        <path
          id="path40"
          d="M.55.48A2.39 2.39 0 000 2.15v26.34a2.41 2.41 0 00.55 1.67l.09.09 14.75-14.76v-.35L.64.39z"
          fill="url(#linear-gradient)"
        />
        <path
          id="path42"
          d="M20.31 20.41l-4.92-4.92v-.35l4.92-4.91.11.06 5.83 3.31c1.67.94 1.67 2.49 0 3.44l-5.83 3.31z"
          fill="url(#linear-gradient-2)"
        />
        <path
          id="path44"
          d="M20.42 20.35l-5-5L.55 30.16a2 2 0 002.45.07l17.39-9.88"
          fill="url(#linear-gradient-3)"
        />
        <path
          id="path46"
          d="M20.42 10.29L3 .4A1.93 1.93 0 00.55.48l14.84 14.84z"
          fill="url(#linear-gradient-4)"
        />
        <path
          id="path48"
          d="M20.31 20.24L3 30.06a2 2 0 01-2.39 0l-.09.09.09.09a2 2 0 002.39 0l17.39-9.88z"
          opacity=".1"
        />
        <path
          id="path50"
          d="M.55 30A2.43 2.43 0 010 28.32v.17a2.41 2.41 0 00.55 1.67l.09-.09z"
          className="cls-7"
        />
        <path
          id="path52"
          d="M26.25 16.86l-5.94 3.38.11.11L26.25 17a2.11 2.11 0 001.25-1.72 2.21 2.21 0 01-1.25 1.58z"
          className="cls-7"
        />
        <path
          id="path54"
          d="M3 .58l23.25 13.19a2.2 2.2 0 011.25 1.55 2.09 2.09 0 00-1.25-1.72L3 .4C1.36-.54 0 .24 0 2.15v.17C0 .42 1.36-.37 3 .58z"
          fill="#fff"
          opacity=".3"
        />
      </g>
    </g>
  </svg>
);

const appleSvg = (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="100"
    viewBox="0 0 1619.125 479.868"
  >
    <path
      d="M1608.385 423.216c0 25.393-20.568 45.96-46.008 45.96H56.748c-25.428 0-46.067-20.567-46.067-45.96V56.7c0-25.38 20.64-46.02 46.067-46.02h1505.616c25.452 0 46.009 20.64 46.009 46.02l.012 366.516z"
      fill="#fff"
    />
    <path
      d="M1562.377 479.868H56.748C25.464 479.868 0 454.464 0 423.216V56.712C0 25.44 25.464 0 56.748 0h1505.616c31.248 0 56.748 25.44 56.748 56.712v366.504c.024 31.248-25.476 56.652-56.735 56.652z"
      fill="#a6a6a6"
    />
    <path d="M1608.385 423.216c0 25.393-20.568 45.96-46.008 45.96H56.748c-25.428 0-46.067-20.567-46.067-45.96V56.7c0-25.38 20.64-46.02 46.067-46.02h1505.616c25.452 0 46.009 20.64 46.009 46.02l.012 366.516z" />
    <path
      d="M361.536 237.408c-.348-38.676 31.668-57.492 33.132-58.368-18.132-26.436-46.235-30.048-56.111-30.336-23.604-2.484-46.5 14.124-58.524 14.124-12.264 0-30.78-13.884-50.736-13.476-25.68.396-49.703 15.264-62.88 38.352-27.191 47.076-6.912 116.256 19.141 154.308 13.031 18.648 28.26 39.444 48.191 38.712 19.5-.792 26.784-12.42 50.316-12.42 23.315 0 30.156 12.42 50.483 11.952 20.929-.324 34.104-18.72 46.681-37.524 15.06-21.348 21.107-42.396 21.348-43.476-.481-.168-40.633-15.504-41.041-61.848zM323.136 123.672c10.487-13.116 17.664-30.96 15.672-49.068-15.181.672-34.164 10.5-45.097 23.328-9.672 11.304-18.312 29.832-16.08 47.256 17.053 1.272 34.561-8.604 45.505-21.516z"
      fill="#fff"
    />
    <linearGradient
      id="e"
      gradientUnits="userSpaceOnUse"
      x1="-589.992"
      y1="1661.375"
      x2="-589.992"
      y2="1625.329"
      gradientTransform="matrix(12 0 0 12 8267.433 -19455.328)"
    >
      <stop offset="0" stopColor="#1a1a1a" stopOpacity=".1" />
      <stop offset=".123" stopColor="#212121" stopOpacity=".151" />
      <stop offset=".308" stopColor="#353535" stopOpacity=".227" />
      <stop offset=".532" stopColor="#575757" stopOpacity=".318" />
      <stop offset=".783" stopColor="#858585" stopOpacity=".421" />
      <stop offset="1" stopColor="#b3b3b3" stopOpacity=".51" />
    </linearGradient>
    <path
      d="M1562.377 0H755.916l315.877 479.868h490.584c31.248 0 56.748-25.404 56.748-56.688V56.712C1619.136 25.44 1593.636 0 1562.377 0z"
      fill="url(#e)"
    />
    <g fill="#fff">
      <path d="M643.98 378.048h-27.252L601.8 331.14h-51.889l-14.22 46.908H509.16l51.42-159.696h31.752l51.648 159.696zm-46.679-66.588l-13.5-41.7c-1.428-4.26-4.116-14.292-8.053-30.084h-.479c-1.584 6.792-4.116 16.824-7.584 30.084l-13.272 41.7h42.888zM775.957 319.056c0 19.584-5.316 35.064-15.961 46.429-9.527 10.115-21.371 15.168-35.496 15.168-15.252 0-26.22-5.437-32.88-16.332v60.42h-25.584V300.744c0-12.301-.323-24.912-.947-37.848h22.5l1.428 18.252h.479c8.532-13.752 21.48-20.629 38.856-20.629 13.584 0 24.924 5.364 33.996 16.104 9.06 10.765 13.609 24.901 13.609 42.433zm-26.065.936c0-11.208-2.52-20.448-7.584-27.732-5.532-7.572-12.96-11.363-22.272-11.363-6.312 0-12.048 2.111-17.172 6.275-5.136 4.2-8.496 9.684-10.067 16.476-.792 3.168-1.188 5.748-1.188 7.789v19.211c0 8.364 2.568 15.433 7.704 21.217 5.136 5.76 11.808 8.651 20.016 8.651 9.637 0 17.137-3.731 22.5-11.136 5.375-7.428 8.063-17.22 8.063-29.388zM908.4 319.056c0 19.584-5.316 35.064-15.96 46.429-9.54 10.115-21.372 15.168-35.508 15.168-15.252 0-26.22-5.437-32.88-16.332v60.42h-25.584V300.744c0-12.301-.324-24.912-.948-37.848h22.5l1.428 18.252h.48c8.52-13.752 21.468-20.629 38.855-20.629 13.572 0 24.912 5.364 34.009 16.104 9.049 10.765 13.608 24.901 13.608 42.433zm-26.076.936c0-11.208-2.531-20.448-7.596-27.732-5.532-7.572-12.936-11.363-22.248-11.363-6.312 0-12.048 2.111-17.196 6.275-5.136 4.2-8.483 9.684-10.056 16.476-.78 3.168-1.2 5.748-1.2 7.789v19.211c0 8.364 2.58 15.433 7.692 21.217 5.136 5.748 11.808 8.651 20.04 8.651 9.647 0 17.147-3.731 22.5-11.136 5.376-7.428 8.064-17.22 8.064-29.388zM1056.48 333.252c0 13.596-4.752 24.648-14.195 33.18-10.393 9.312-24.9 13.98-43.501 13.98-17.184 0-30.96-3.312-41.352-9.948l5.916-21.324c11.22 6.648 23.544 9.96 36.96 9.96 9.648 0 17.148-2.184 22.5-6.516 5.363-4.344 8.076-10.152 8.076-17.4 0-6.491-2.244-11.928-6.648-16.355-4.428-4.416-11.748-8.532-22.031-12.312-27.961-10.428-41.953-25.68-41.953-45.744 0-13.104 4.944-23.832 14.809-32.22 9.864-8.376 22.944-12.563 39.216-12.563 14.532 0 26.64 2.532 36.252 7.584l-6.42 20.855c-9.048-4.896-19.261-7.344-30.685-7.344-9.023 0-16.104 2.22-21.168 6.636-4.26 3.948-6.42 8.761-6.42 14.472 0 6.301 2.461 11.533 7.356 15.637 4.248 3.779 12 7.896 23.208 12.312 13.752 5.544 23.855 12 30.324 19.416 6.516 7.414 9.756 16.666 9.756 27.694zM1141.285 282.096h-28.201v55.908c0 14.22 4.969 21.312 14.929 21.312 4.571 0 8.364-.385 11.364-1.188l.707 19.428c-5.039 1.885-11.676 2.832-19.896 2.832-10.104 0-18-3.084-23.7-9.252-5.676-6.168-8.531-16.5-8.531-31.044v-58.044h-16.801v-19.2h16.801v-21.084l25.127-7.584v28.668h28.201v19.248zM1268.268 319.524c0 17.699-5.063 32.231-15.168 43.596-10.572 11.7-24.636 17.532-42.168 17.532-16.92 0-30.372-5.604-40.404-16.8-10.032-11.221-15.048-25.356-15.048-42.408 0-17.845 5.184-32.46 15.516-43.824 10.356-11.376 24.301-17.063 41.832-17.063 16.896 0 30.469 5.615 40.74 16.823 9.817 10.872 14.7 24.912 14.7 42.144zm-26.52.588c0-10.549-2.279-19.597-6.852-27.169-5.364-9.144-13.044-13.715-22.992-13.715-10.248 0-18.107 4.571-23.46 13.715-4.584 7.572-6.864 16.776-6.864 27.648 0 10.561 2.28 19.632 6.864 27.181 5.532 9.144 13.248 13.716 23.244 13.716 9.78 0 17.448-4.668 22.992-13.944 4.705-7.752 7.068-16.86 7.068-27.432zM1351.465 285.396c-2.532-.469-5.244-.709-8.064-.709-9 0-15.96 3.385-20.855 10.2-4.248 6-6.385 13.584-6.385 22.74v60.42h-25.584V299.16c0-13.26-.252-25.356-.744-36.252h22.285l.936 22.031h.708c2.712-7.571 6.96-13.68 12.792-18.252 5.7-4.115 11.855-6.168 18.492-6.168 2.363 0 4.5.168 6.396.469l.023 24.408zM1465.885 315.024c0 4.584-.301 8.447-.937 11.604h-76.752c.288 11.376 4.009 20.088 11.136 26.088 6.469 5.353 14.832 8.04 25.104 8.04 11.364 0 21.731-1.8 31.056-5.436l4.008 17.748c-10.896 4.752-23.76 7.116-38.604 7.116-17.855 0-31.872-5.257-42.072-15.744-10.176-10.5-15.275-24.612-15.275-42.288 0-17.353 4.74-31.812 14.231-43.344 9.937-12.312 23.364-18.469 40.261-18.469 16.596 0 29.159 6.156 37.691 18.469 6.756 9.756 10.153 21.852 10.153 36.216zm-24.397-6.636c.18-7.596-1.5-14.136-4.968-19.668-4.429-7.128-11.244-10.68-20.376-10.68-8.364 0-15.18 3.468-20.364 10.428-4.26 5.532-6.792 12.18-7.571 19.896l53.279.024z" />
    </g>
    <g fill="#fff">
      <path d="M584.965 161.196H571.56l-7.332-23.052h-25.5l-6.996 23.052h-13.044l25.272-78.492h15.6l25.405 78.492zm-22.945-32.724l-6.636-20.496c-.696-2.1-1.98-6.984-3.96-14.784h-.24c-.816 3.372-1.98 8.268-3.732 14.784l-6.516 20.496h21.084zM648.156 104.604l-21.432 56.592h-12.229l-20.735-56.592h13.512l9.672 29.928c1.632 5.004 3.024 9.78 4.068 14.316h.348c.937-4.068 2.328-8.844 4.068-14.316l9.552-29.928h13.176zM693.78 161.196l-.936-6.517h-.349c-3.84 5.244-9.432 7.8-16.535 7.8-10.129 0-17.353-7.104-17.353-16.656 0-13.968 12.108-21.192 33.072-21.192v-1.044c0-7.452-3.96-11.184-11.76-11.184-5.593 0-10.488 1.404-14.784 4.2l-2.557-8.268c5.244-3.264 11.761-4.896 19.452-4.896 14.784 0 22.248 7.8 22.248 23.412v20.844c0 5.712.24 10.14.816 13.512l-11.314-.011zm-1.752-28.188c-13.979 0-20.964 3.384-20.964 11.412 0 5.94 3.612 8.844 8.616 8.844 6.407 0 12.348-4.884 12.348-11.52v-8.736zM732.288 95.28c-4.188 0-7.452-3.264-7.452-7.572s3.373-7.452 7.692-7.452c4.308 0 7.8 3.144 7.681 7.452 0 4.548-3.252 7.572-7.921 7.572zm6.528 65.916H726.24v-56.592h12.576v56.592zM773.736 161.196H761.16v-82.56h12.576v82.56zM827.184 161.196l-.937-6.517h-.347c-3.84 5.244-9.432 7.8-16.536 7.8-10.128 0-17.352-7.104-17.352-16.656 0-13.968 12.107-21.192 33.071-21.192v-1.044c0-7.452-3.96-11.184-11.76-11.184-5.592 0-10.488 1.404-14.784 4.2l-2.567-8.28c5.244-3.264 11.76-4.896 19.452-4.896 14.784 0 22.247 7.8 22.247 23.412v20.844c0 5.712.253 10.14.805 13.512h-11.292zm-1.752-28.188c-13.98 0-20.964 3.384-20.964 11.412 0 5.94 3.611 8.844 8.615 8.844 6.408 0 12.349-4.884 12.349-11.52v-8.736zM888.625 162.48c-8.028 0-13.957-3.384-17.797-10.02h-.252l-.72 8.736H859.14c.348-4.536.468-9.672.468-15.252V78.636h12.588v34.248h.24c3.731-6.288 9.769-9.432 18.048-9.432 13.632 0 23.184 11.652 23.184 28.644 0 17.568-10.608 30.384-25.043 30.384zm-2.557-49.152c-7.236 0-13.859 6.288-13.859 15.024v9.9c0 7.8 5.951 14.208 13.644 14.208 9.42 0 15.024-7.68 15.024-19.908-.013-11.412-5.845-19.224-14.809-19.224zM944.832 161.196h-12.563v-82.56h12.563v82.56zM1013.293 135.924h-37.752c.252 10.716 7.331 16.764 17.819 16.764 5.592 0 10.716-.936 15.252-2.676l1.956 8.736c-5.352 2.328-11.64 3.492-18.972 3.492-17.712 0-28.188-11.184-28.188-28.524 0-17.352 10.729-30.396 26.772-30.396 14.437 0 23.532 10.716 23.532 26.904.048 2.208-.06 4.188-.419 5.7zm-11.533-8.964c0-8.736-4.429-14.904-12.468-14.904-7.225 0-12.912 6.288-13.752 14.904h26.22zM1089.516 162.48c-16.536 0-27.252-12.348-27.252-29.112 0-17.472 10.944-29.928 28.2-29.928 16.283 0 27.252 11.76 27.252 29.004.001 17.688-11.304 30.036-28.2 30.036zm.48-49.848c-9.084 0-14.903 8.496-14.903 20.376 0 11.652 5.94 20.148 14.784 20.148s14.771-9.084 14.771-20.388c.012-11.52-5.808-20.136-14.652-20.136zM1185.324 161.196h-12.563V128.7c0-10.008-3.841-15.024-11.412-15.024-7.452 0-12.588 6.408-12.588 13.86v33.66h-12.564V120.78c0-5.004-.132-10.368-.468-16.188h11.064l.588 8.736h.348c3.359-6.048 10.248-9.9 17.928-9.9 11.868 0 19.668 9.084 19.668 23.868v33.9h-.001zM1267.608 114.036h-13.836v27.48c0 6.996 2.437 10.488 7.32 10.488 2.22 0 4.092-.24 5.592-.588l.349 9.552c-2.449.937-5.725 1.404-9.769 1.404-9.912 0-15.828-5.472-15.828-19.8v-28.536h-8.256v-9.432h8.256V94.236l12.336-3.732v14.088h13.836v9.444zM1334.209 161.196h-12.589V128.94c0-10.128-3.84-15.252-11.411-15.252-6.517 0-12.564 4.428-12.564 13.392v34.116h-12.588v-82.56h12.588v33.996h.24c3.96-6.168 9.672-9.204 17.004-9.204 11.988 0 19.32 9.312 19.32 24.108v33.66zM1398.469 135.924h-37.74c.24 10.716 7.32 16.764 17.809 16.764 5.604 0 10.715-.936 15.252-2.676l1.968 8.736c-5.353 2.328-11.652 3.492-18.984 3.492-17.712 0-28.188-11.184-28.188-28.524 0-17.352 10.729-30.396 26.772-30.396 14.437 0 23.532 10.716 23.532 26.904.046 2.208-.074 4.188-.421 5.7zm-11.533-8.964c0-8.736-4.416-14.904-12.456-14.904-7.236 0-12.924 6.288-13.752 14.904h26.208z" />
    </g>
  </svg>
);

const whatsappSvg = (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    fill="#fffaf0"
    width="18"
    height="18"
    viewBox="0 0 24 24"
  >
    {" "}
    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
  </svg>
);

const donateSvg = (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="https://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    fill="#000"
    className="donate-icon"
    width="25"
    height="25"
    viewBox="0 0 435.047 435.047"
    style={{ enableBackground: "new 0 0 435.047 435.047" }}
    space="preserve"
  >
    <g>
      <g>
        <path
          d="M202.011,205.437c-6.501-2.273-9.219-3.666-9.219-6.391c0-4.857,5.021-6.143,7.679-6.143c5.097,0,6.143,2.068,6.143,5.172
v0.242c0,2.232,1.81,4.043,4.039,4.043h1.041c2.23,0,4.039-1.807,4.041-4.039l0.006-7.01c0-1.133-0.475-2.215-1.308-2.98
c-2.535-2.326-5.821-3.617-10.003-3.924v-4.598c0-2.232-1.811-4.041-4.039-4.041h-0.974c-2.229,0-4.04,1.809-4.04,4.041v4.918
c-6.099,1.684-11.879,7.248-11.879,14.643c0,8.82,7.777,11.482,14.64,13.83c7.115,2.438,10.091,4.021,10.091,7.508
c0,5.041-5.234,6.386-8.326,6.386c-3.125,0-6.991-0.892-8.036-2.361c-0.457-0.654-0.765-1.926-0.915-3.785
c-0.172-2.098-1.923-3.715-4.027-3.715h-0.821c-1.079,0-2.11,0.43-2.871,1.198c-0.758,0.764-1.18,1.799-1.17,2.877l0.063,7.948
c0.013,1.802,1.216,3.371,2.95,3.858c0.175,0.05,0.408,0.103,0.644,0.154l0.192,0.041c3.603,1.006,6.862,1.877,9.467,2.207v6.691
c0,2.23,1.811,4.039,4.04,4.039h0.974c2.229,0,4.039-1.809,4.039-4.039v-6.838c6.717-1.412,13.094-6.979,13.094-14.824
C217.523,210.867,208.922,207.857,202.011,205.437z"
        />
        <path
          d="M410.734,74.918V0c-21.198,9.292-61.076,22.585-79.635,23.641c-18.56,1.056-105.775-12.639-129.403-6.725
c-19.016,4.76-123.429,83.334-154.574,105.002c-49.723,34.593-5.72,40.138,15.158,32.136
c21.008-8.052,88.712-45.871,88.712-45.871c-0.214,7.662,0.944,18.508,7.797,30.219c0,0,7.75,10.864,17.037,21.499
c-20.04,9.137-34.006,29.351-34.006,52.773c0,19.896,10.078,37.48,25.396,47.926H67.012c-5.549,0-10.048,4.498-10.048,10.047
v154.35c0,5.553,4.499,10.051,10.048,10.051h265.562c5.548,0,10.047-4.498,10.047-10.051v-154.35
c0-5.549-4.499-10.047-10.047-10.047H232.371c15.316-10.445,25.395-28.029,25.395-47.926c0-14.541-5.394-27.838-14.27-38.025
c-0.106-0.089-0.2-0.186-0.289-0.284c14.482-7.218,29.704-20.151,66.559-35.225C371.839,113.751,392.863,84.917,410.734,74.918z
M239.722,133.696c-11.633,8.212-19.572,16.233-24.203,23.19c-2.611-0.737-5.295-1.295-8.039-1.664
c-2.399-7.765-6.52-17.979-12.799-31.504c0,0-2.882-6.779-1.932-14.885c2.37-9.058,10.55-18.772,33.664-21.755
c38.92-5.022,44.443,14.654,26.855,35.14C249.515,126.107,244.982,129.983,239.722,133.696z M245.2,284.544
c5.521,0,10.014,4.49,10.014,10.013c0,5.52-4.491,10.012-10.014,10.012h-90.814c-5.521,0-10.012-4.492-10.012-10.012
c0-5.521,4.491-10.013,10.012-10.013H245.2z M199.793,255.376c-23.547,0-42.705-19.155-42.705-42.703
c0-23.547,19.158-42.703,42.705-42.703c3.474,0,6.847,0.426,10.081,1.213c-0.005,6.768,5.262,10.629,13.948,9.771
c1.334-0.131,2.628-0.316,3.893-0.551c9.042,7.838,14.78,19.393,14.78,32.27C242.496,236.221,223.34,255.376,199.793,255.376z"
        />
      </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
);

const applePodcast = (
  <svg
    version="1.1"
    id="Livello_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="25px"
    height="25px"
    viewBox="0 0 300 300"
    enableBackground="new 0 0 300 300"
  >
    <g id="XMLID_632_">
      <linearGradient
        id="XMLID_2_"
        gradientUnits="userSpaceOnUse"
        x1="150"
        y1="0"
        x2="150"
        y2="300"
      >
        <stop offset="0" style={{ stopColor: "#F452FF" }} />
        <stop offset="1" style={{ stopColor: "#832BC1" }} />
      </linearGradient>
      <path
        id="XMLID_662_"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="url(#XMLID_2_)"
        d="M294.1,260c-2.9,7.4-9.6,17.8-19.2,25.2
		c-5.5,4.2-12.1,8.3-21.1,11c-9.6,2.9-21.5,3.8-36.3,3.8h-135c-14.8,0-26.6-1-36.3-3.8c-9-2.7-15.6-6.7-21.1-11
		c-9.5-7.3-16.3-17.8-19.2-25.2C0.1,245.1,0,228.2,0,217.5l0,0v-135l0,0C0,71.8,0.1,54.9,5.9,40c2.9-7.4,9.6-17.8,19.2-25.2
		c5.5-4.2,12.1-8.3,21.1-11C55.9,1,67.7,0,82.5,0l0,0h135l0,0c14.8,0,26.6,1,36.3,3.8c9,2.7,15.6,6.7,21.1,11
		c9.5,7.3,16.3,17.8,19.2,25.2c5.9,14.9,5.9,31.9,5.9,42.5v135C300,228.2,299.9,245.1,294.1,260z"
      />
      <g>
        <path
          id="XMLID_657_"
          fill="#FFFFFF"
          d="M175.7,181.1c-0.4-3.6-1.6-6.2-4-8.6c-4.5-4.7-12.4-7.8-21.7-7.8c-9.3,0-17.2,3-21.7,7.8
			c-2.3,2.5-3.6,5-4,8.6c-0.8,7-0.3,13,0.5,22.7c0.8,9.2,2.3,21.5,4.2,33.9c1.4,8.9,2.5,13.7,3.5,17.1c1.7,5.6,7.8,10.4,17.5,10.4
			c9.7,0,15.9-4.9,17.5-10.4c1-3.4,2.1-8.2,3.5-17.1c1.9-12.5,3.4-24.7,4.2-33.9C176.1,194.1,176.5,188.1,175.7,181.1z"
        />
        <path
          id="XMLID_655_"
          fill="#FFFFFF"
          d="M174.6,130.1c0,13.6-11,24.6-24.6,24.6s-24.6-11-24.6-24.6c0-13.6,11-24.6,24.6-24.6
			S174.6,116.6,174.6,130.1z"
        />
        <path
          id="XMLID_653_"
          fill="#FFFFFF"
          d="M149.7,33.2C92.3,33.4,45.3,80,44.5,137.4c-0.6,46.5,29.1,86.3,70.6,100.9
			c1,0.4,2-0.5,1.9-1.5c-0.5-3.6-1.1-7.2-1.5-10.8c-0.2-1.3-1-2.3-2.1-2.9c-32.8-14.3-55.7-47.2-55.3-85.3
			c0.5-50,41.3-90.7,91.2-91.1c51.1-0.4,92.8,41,92.8,92c0,37.7-22.8,70.1-55.3,84.4c-1.2,0.5-2,1.6-2.1,2.9
			c-0.5,3.6-1,7.2-1.5,10.8c-0.2,1.1,0.9,1.9,1.9,1.5c41.1-14.4,70.6-53.6,70.6-99.6C255.5,80.5,208,33.1,149.7,33.2z"
        />
        <path
          id="XMLID_651_"
          fill="#FFFFFF"
          d="M147.3,68.2c-37.4,1.4-67.4,32.3-67.9,69.7c-0.3,24.6,12,46.4,30.9,59.3
			c0.9,0.6,2.2-0.1,2.2-1.2c-0.3-4.3-0.3-8.1-0.1-12.1c0.1-1.3-0.4-2.5-1.4-3.4c-11.5-10.8-18.5-26.2-18.1-43.2
			c0.8-30,24.9-54.4,54.9-55.6c32.6-1.3,59.4,24.9,59.4,57.1c0,16.4-7,31.2-18.1,41.7c-0.9,0.9-1.4,2.1-1.4,3.4
			c0.2,3.9,0.1,7.7-0.1,12c-0.1,1.1,1.2,1.9,2.2,1.2c18.6-12.7,30.9-34.2,30.9-58.4C220.8,98.9,187.5,66.6,147.3,68.2z"
        />
      </g>
    </g>
  </svg>
);

const googlePodcast = (
  <svg
    height="25"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <g fill="none">
      <path
        d="M64 238.545v34.91c0 17.673-14.327 32-32 32s-32-14.327-32-32v-34.91c0-17.673 14.327-32 32-32s32 14.327 32 32z"
        fill="#0066d9"
      />
      <path
        d="M448.013 239.455a32.6 32.6 0 0 1-.013-.91c0-17.673 14.327-32 32-32s32 14.327 32 32c0 .304-.004.608-.013.91H512v34.909h-.013c-.48 17.252-14.618 31.09-31.987 31.09s-31.506-13.838-31.987-31.09H448v-34.91h.013z"
        fill="#4285f4"
      />
      <path
        d="M174.545 343.273v34.909c0 17.673-14.326 32-32 32s-32-14.327-32-32v-34.91c0-17.672 14.327-32 32-32s32 14.328 32 32zM174.545 133.818V248h-.008c-.386 17.337-14.562 31.273-31.992 31.273S110.94 265.337 110.554 248h-.009V133.818c0-17.673 14.327-32 32-32s32 14.327 32 32z"
        fill="#ea4335"
      />
      <path
        d="M337.455 168.727c0 17.673 14.326 32 32 32s32-14.327 32-32v-34.909c0-17.673-14.327-32-32-32s-32 14.327-32 32z"
        fill="#34a853"
      />
      <path
        d="M224 66.91c0 17.672 14.327 32 32 32s32-14.328 32-32V32c0-17.673-14.327-32-32-32s-32 14.327-32 32zM224 445.09c0-17.672 14.327-32 32-32s32 14.328 32 32V480c0 17.673-14.327 32-32 32s-32-14.327-32-32z"
        fill="#fab908"
      />
      <path
        d="M337.455 264.727c0-17.673 14.326-32 32-32s32 14.327 32 32v113.455c0 17.673-14.327 32-32 32s-32-14.327-32-32z"
        fill="#34a853"
      />
      <path
        d="M288 162.91v186.18c0 17.674-14.327 32-32 32s-32-14.326-32-32V162.91c0-17.674 14.327-32 32-32s32 14.326 32 32z"
        fill="#fab908"
      />
    </g>
  </svg>
);

const spotify = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="25"
    width="25"
    viewBox="0 0 1333.33 1333.3"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    imageRendering="optimizeQuality"
    fillRule="evenodd"
    clipRule="evenodd"
  >
    <path
      d="M666.66 0C298.48 0 0 298.47 0 666.65c0 368.19 298.48 666.65 666.66 666.65 368.22 0 666.67-298.45 666.67-666.65C1333.33 298.49 1034.88.03 666.65.03l.01-.04zm305.73 961.51c-11.94 19.58-37.57 25.8-57.16 13.77-156.52-95.61-353.57-117.26-585.63-64.24-22.36 5.09-44.65-8.92-49.75-31.29-5.12-22.37 8.84-44.66 31.26-49.75 253.95-58.02 471.78-33.04 647.51 74.35 19.59 12.02 25.8 37.57 13.77 57.16zm81.6-181.52c-15.05 24.45-47.05 32.17-71.49 17.13-179.2-110.15-452.35-142.05-664.31-77.7-27.49 8.3-56.52-7.19-64.86-34.63-8.28-27.49 7.22-56.46 34.66-64.82 242.11-73.46 543.1-37.88 748.89 88.58 24.44 15.05 32.16 47.05 17.12 71.46V780zm7.01-189.02c-214.87-127.62-569.36-139.35-774.5-77.09-32.94 9.99-67.78-8.6-77.76-41.55-9.98-32.96 8.6-67.77 41.56-77.78 235.49-71.49 626.96-57.68 874.34 89.18 29.69 17.59 39.41 55.85 21.81 85.44-17.52 29.63-55.89 39.4-85.42 21.8h-.03z"
      fill="#1ed760"
      fillRule="nonzero"
    />
  </svg>
);

export {
  googleSvg2,
  appleSvg,
  whatsappSvg,
  donateSvg,
  applePodcast,
  googlePodcast,
  spotify,
};